// extracted by mini-css-extract-plugin
export default {"createEditPatientContainer":"CreateEditPatient_createEditPatientContainer__ez1QK"};